import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import AppRights from "../../services/AppRights";
import { _ACTIVE_RADIO_GROUP, _ROLES_BACK } from "../../utils/constants";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { BasicListContext } from "../../contexts/BasicListContext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { AccountsList } from "../../components/parameters/accounts/AccountsList";
import { useContext, useEffect, useState } from "react";
import BasicRadioGroup from "../../components/form/BasicRadioGroup";
import _ from "lodash";
import { getDataGeneric } from "../../repository/DataGeneric";
import { RequestHelper } from "../../utils/requestHelper";
import { _ROUTES } from "../../utils/_routes_constants";
import { getIdFromIRI } from "../../utils/function";

export const Accounts = () => {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [activities, setActivities] = useState([]);
  const { extraQueryParams, setExtraQueryParams } =
    useContext(BasicListContext);

  useEffect(() => {
    if (activities.length === 0) {
      // Request to get activities
      const rq = new RequestHelper();
      getDataGeneric(
        rq,
        { active: 1, "groups[]": "select:get", "order[name]": "ASC", "pagination": false },
        setActivities,
        _ROUTES.ACTIVITIES,
      );
    }
  }, []);

  return (
    <>
      <AppRights roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]} />
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}
      >
        <Box
          width={"100%"}
          display={"flex"}
          gap={1}
          alignItems={"baseline"}
          sx={{
            borderBottom: "1px solid #ccc",
          }}
        >
          <AccountTreeIcon />
          <Typography variant="h6" component="div">
            Accounts List
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            <TextField
              id="outlined-basic"
              label="Find"
              variant="outlined"
              size="small"
              name="customFind"
              onChange={(e) => {
                setExtraQueryParams({
                  ...extraQueryParams,
                  customFind: e.target.value ? e.target.value : null,
                });
              }}
            />

            <BasicRadioGroup
              choices={_ACTIVE_RADIO_GROUP}
              defaultValue={extraQueryParams?.active}
              onChange={(e) => {
                setExtraQueryParams({
                  ...extraQueryParams,
                  active: e.target.value,
                });
              }}
            />

            <FormGroup>
              <FormControlLabel
                label="Only grouped"
                control={<Checkbox />}
                name="apGroup"
                onChange={(e) => {
                  setExtraQueryParams({
                    ...extraQueryParams,
                    apGroup: e.target.checked,
                  });
                }}
              />
            </FormGroup>

            <Select
              size="small"
              variant="outlined"
              name="activity"
              defaultValue={0}
              onChange={(e) => {
                if (e.target.value === 0) {
                  setExtraQueryParams(_.omit(extraQueryParams, ["activity"]));
                  return;
                }
                setExtraQueryParams({
                  ...extraQueryParams,
                  activity: e.target.value,
                });
              }}
              value={extraQueryParams?.activity ? extraQueryParams.activity : 0}
            >
              <MenuItem key={0} value={0}>
                All
              </MenuItem>
              {activities.map((activity) => (
                <MenuItem
                  key={getIdFromIRI(activity["@id"])}
                  value={activity["@id"]}
                >
                  {activity.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box>
            <Button
              variant="contained"
              size="small"
              title={"Add account"}
              startIcon={<AddCircleIcon />}
              color="success"
              onClick={() => {
                // Modal create user
                setEditData(null);
                setShowModal(true);
              }}
            >
              {"Add account"}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          width: "100%",
        }}
      >
        <AccountsList
          editData={editData}
          setEditData={setEditData}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      </Box>
    </>
  );
};
